import { render, staticRenderFns } from "./admissionticket.vue?vue&type=template&id=b1889514&scoped=true&"
import script from "./admissionticket.vue?vue&type=script&lang=js&"
export * from "./admissionticket.vue?vue&type=script&lang=js&"
import style0 from "./admissionticket.vue?vue&type=style&index=0&id=b1889514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1889514",
  null
  
)

export default component.exports